import { render } from "./VueLoading.vue?vue&type=template&id=755fc859"
import script from "./VueLoading.vue?vue&type=script&lang=js"
export * from "./VueLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__